module.exports = __webpack_public_path__ + "static/aws-26a5e64830fda67e05f4d732dc7ace42.png";